<template>
	<div class="Expander">
		<div
			class="Expander__trigger flex items-center"
			@click="open = !open"
			:class="open ? 'active' : 'beforeBorder'"
		>
			<svg
				class="Expander__trigger-Icon"
				:class="{ open: open }"
				width="40"
				height="12"
				stroke="white"
			>
				<polyline
					points="12,2 20,10 28,2"
					stroke-width="3"
					fill="none"
				></polyline>
			</svg>
			{{ title }}
		</div>
		<transition :name="animation">
			<div class="Expander__body" v-show="open">
				<slot></slot>
			</div>
		</transition>
	</div>
</template>
<script>
export default {
	data() {
		return {
			open: false
		}
	},
	props: {
		title: String,
		animation: {
			type: String,
			default: 'bottomToTop'
			// validator: prop => ['leftToRight', 'bounceIn', 'bottomToTop'].includes(prop)
		}
	}
}
</script>
<style>
.bottomToTop-enter-active {
	animation: bottomToTop 0.3s forwards;
}
.bottomToTop-leave-active {
	animation: bottomToTop 0.1s reverse;
}
@keyframes bottomToTop {
	0% {
		opacity: 0;
		transform: translateY(100%);
	}
	100% {
		transform: translateY(0);
	}
}
.beforeBorder {
	position: relative;
}
.beforeBorder:before {
	transition: opacity 0.1s linear, transform 0.5s ease-in-out;
	position: absolute;
	border-bottom: 1px solid currentColor;
	content: '';
	width: 100%;
	left: 0;
	bottom: -1px;
}
.beforeBorder:not(:hover)::before {
	transform: scaleX(0);
	opacity: 0;
}
.Expander__trigger {
	cursor: pointer;
	font-weight: 600;
	padding: 0.6rem 0.5rem;
}
.Expander__trigger-Icon {
	transition: 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.Expander__trigger-Icon.open {
	transform: rotate(180deg);
}
.Expander__body {
	padding: 1rem 1.5rem;
	border: #f1f1f1 solid 1px;
}
</style>
